module.exports = __webpack_public_path__ + "img/画板 6.9bd4500e.jpg";